module.exports = __webpack_public_path__ + "img/links.2fc651a2.svg";